import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "order-draft-editor"
}
const _hoisted_2 = {
  key: 1,
  class: "order-draft-editor"
}
const _hoisted_3 = { class: "order-draft__section" }
const _hoisted_4 = { class: "order-draft__section" }
const _hoisted_5 = { class: "order-draft__actions-container order_bottom_sheet" }
const _hoisted_6 = { class: "action-group wide" }
const _hoisted_7 = { class: "bold" }
const _hoisted_8 = { class: "bold" }
const _hoisted_9 = { class: "medium" }
const _hoisted_10 = { class: "action-group wide" }
const _hoisted_11 = { class: "action-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return ($setup.props.modelValue && !$setup.props.modelValue?.raw)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[4] || (_cache[4] = [
        _createElementVNode("span", { class: "empty-placeholder" }, "Drafts is missing required data and cannot be edited", -1)
      ])))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode($setup["ProductSearch"], {
          show: $setup.showSearch,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($setup.showSearch) = $event)),
          onSelect: $setup.commitSearch
        }, null, 8, ["show"]),
        _createElementVNode("section", _hoisted_3, [
          _createVNode($setup["AddressEditor"], {
            modelValue: $setup.props.modelValue.raw.shipping_address,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.props.modelValue.raw.shipping_address) = $event)),
            onSave: $setup.updateDraftAddress,
            editing: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("section", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("h6", { class: "order-draft__section-head" }, "Products", -1)),
          _createVNode($setup["DraftProductList"], {
            items: $setup.props.modelValue.raw.products,
            catalogue: $setup.props.modelValue.raw.catalogue,
            onSearch: $setup.searchProducts
          }, null, 8, ["items", "catalogue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("header", _hoisted_6, [
            _createElementVNode("h3", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString($setup.props.modelValue.id), 1),
              ($props.link)
                ? (_openBlock(), _createBlock($setup["ExternalLinkIcon"], {
                    key: 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openMirrorUrl($props.link)))
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("h6", _hoisted_9, _toDisplayString($setup.props.modelValue.raw.service), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_q_btn, {
              class: "action__ignore",
              onClick: $setup.ignoreDraft,
              color: "primary",
              unelevated: "",
              outline: "",
              rounded: ""
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Ignore")
              ])),
              _: 1
            }),
            _createVNode(_component_q_btn, {
              class: "action__save",
              onClick: $setup.commitDraft,
              color: "primary",
              unelevated: "",
              rounded: ""
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("Confirm & Create order")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_q_btn, {
              class: "close-details",
              round: "",
              flat: "",
              icon: "clear",
              size: "sm",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
            })
          ])
        ])
      ]))
}